/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import BestInstagramApps from "views/articles/BestInstagramApps"
import Link from "next/link"
import { AppInterface } from "types/types"
import AppsList from "components/AppsList"
import AppsListItem from "components/AppsListItem"

const AddAppollowToYourHomeScreenTR = ({
  apps,
  otherApps,
}: {
  apps: AppInterface[]
  otherApps: AppInterface[]
}) => {
  const article = BestInstagramApps["tr"]
  return (
    <InstantArticle {...article}>
      <div style={{ textAlign: "justify" }}>
        <p>
          Instagram, işletmelerin markalarını büyütmeleri için mükemmel bir
          platformdur. Fotoğraflar, videolar ve hatta canlı videolar için
          kullanabilirsiniz. Ancak, Instagram&apos;dan en iyi şekilde
          yararlanmak istiyorsanız, bu blog gönderisinde, şimdiye kadar
          karşılaştığımız Instagram için en iyi iOS uygulamalarının ve
          araçlarının bir listesini derledik.
        </p>
        <h2>VSCO</h2>
        <p>
          VSCO, birçok filtre ve efekt içeren bir fotoğraf düzenleme
          uygulamasıdır. Uygulamayı indirmek ücretsizdir, ancak bazı premium
          özellikler için ödeme de yapabilirsiniz. VSCO ile kullanmak
          istediğiniz tüm sosyal medya hesaplarını eklemek de dahil olmak üzere
          hesabınızı dakikalar içinde kurabilirsiniz.
        </p>
        <p>
          VSCO&apos;ın arayüzü, daha önce Instagram kullanmış olan herkes için
          yeterince basit, ancak yine de Facebook veya Twitter gibi sosyal medya
          platformlarında fotoğraflarıyla yaratıcı olmak isteyenler için pek çok
          seçenek sunuyor!
        </p>
        <p>
          Bu uygulamada yerleşik çeşitli farklı filtreler bulacaksınız - eski
          film tonlarından (o retro hissi elde etmeye çalışıyorsanız mükemmel)
          kırmızılar/maviler/yeşiller gibi parlak renklere kadar her şeyi
          bulacaksınız; Kullanıcıların evlerinin içindeki manzaraları veya
          yurtdışındaki dünya seyahat yerlerini fotoğraflarken gerçekten
          benzersiz bir şey yaratabilmeleri için bu uygulamada bazı suluboya
          efektleri bile var!
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 588013838)} />
        </div>
        <h2>Layout from Instagram</h2>
        <p>
          Layout from Instagram, Instagram profil resminiz, kapak fotoğrafınız
          ve hikayeniz için profesyonel görünümlü düzenler oluşturmanıza olanak
          tanıyan ücretsiz bir araçtır. Birden fazla fotoğrafı tek bir kolajda
          birleştirmek veya farklı boyutlarda bir fotoğraf mozaiği oluşturmak
          için kullanabilirsiniz.
        </p>
        <p>
          Layout from Instagram, hem iOS hem de Android akıllı telefonlarda ve
          ayrıca macOS veya Windows 10 çalıştıran bilgisayarlarda
          kullanılabilir.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 967351793)} />
        </div>
        <h2>Canva</h2>
        <p>
          Canva, Instagram profiliniz için grafikler oluşturmanıza yardımcı
          olabilecek ücretsiz ve kullanımı kolay bir çevrimiçi tasarım aracıdır.
          Kolajlar, memler, logolar ve daha fazlasını yapmak için Canva&apos;yı
          kullanabilirsiniz.
        </p>
        <p>
          Canva, gönderinizin veya fotoğrafınızın temasına uygun olanı kolayca
          bulabilmeniz için aralarından seçim yapabileceğiniz yüzlerce şablona
          sahiptir. Henüz aklınızda bir şablon yoksa, fotoğrafları doğrudan
          telefonunuzdan veya bilgisayarınızdan da yükleyebilirsiniz!
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 897446215)} />
        </div>
        <h2>Unfold</h2>
        <p>
          Instagram hikayeleri oluşturmakla ilgileniyorsanız, Unfold mutlaka
          sahip olmanız gereken bir uygulamadır. Yalnızca birkaç dakika içinde
          profesyonel görünümlü hikayeler oluşturmak için kullanabileceğiniz çok
          çeşitli şablonlara ve tasarım öğelerine sahiptir.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1247275033)} />
        </div>
        <h2>Diğer</h2>
        <p>
          Ayrıca, kullanıcıların neleri tercih ettiğini öğrenin, işte
          kullanıcılarımızın Instagram ile kullandıkları uygulamalardan bazıları
        </p>
        <div dir="ltr">
          <AppsList apps={otherApps} title="" />
        </div>
        <div className="card mt-4">
          <div className="card-body">
            <div className="text-center">
              <i className="fa fa-star color-yellow-dark fa-2x mb-3 "></i>
            </div>
            <p className="color-white">
              Instagram&apos;dan en iyi şekilde yararlanmak için kullandığınız
              herhangi bir favori uygulamanız var mı? Favori uygulamalarınızı
              Appollow&apos;un{" "}
              <Link href="/submit">
                <span className="text-white text-decoration-underline">
                  paylaşım sayfası
                </span>
              </Link>{" "}
              aracılığıyla gönderebilirsiniz.
            </p>
          </div>
          <div className="card-overlay bg-highlight opacity-95" />
          <div className="card-overlay dark-mode-tint" />
        </div>
      </div>
    </InstantArticle>
  )
}

export default AddAppollowToYourHomeScreenTR
